export default {
    'diagram3b3-7': {
        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
        'element_1_1': 'Cities north of the Alps, dependent on horses and oxen for motive power, could not exist without hay',
        'element_1_2': 'The invention of hay moved the center of urban civilization from the Mediterranean basin to Northern and Western Europe',
        'element_1_3': 'In this way, hay moved the greatness of Rome to North and West',
        'element_1_4': 'The Roman Empire fed their horses year round on grass, so did not need to make hay',
        'element_1_5': 'Abundant hay allowed these Northern populations to grow and flourish',
        'hint-title': 'Hint',
        'resubmit-title': 'Resubmit'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b3/diagram7/i18n/en.js